/* @flow */
import * as React from 'react';

import Checkbox from 'components/Checkbox.jsx';
import type { Props as CheckboxProps } from 'components/Checkbox.jsx';

import getField from '../ComposableTableField.jsx';
import type { Field } from '../ComposableTableField.jsx';

export function getCheckboxCellGenerator(input: {
  fieldForAction?: Field,
  onClickAction: (SyntheticEvent<>, any) => void,
  checked: any => boolean,
  checkboxProps?: $Shape<CheckboxProps>,
}) {
  return (data: Object) => {
    const checked = input.checked(getField(data, input.fieldForAction));
    return (
      <Checkbox
        {...input.checkboxProps}
        checked={checked}
        readOnly
        onClick={event => input.onClickAction(event, getField(data, input.fieldForAction))}
      />
    );
  };
}
